import anime from 'animejs';
import { isTouchDevice } from '@/scripts/utils';

export function buttonInit(el) {
  const elToTween = el instanceof HTMLElement ? el : el.node;
  const bg = elToTween.querySelector('.button__bg');
  const content = elToTween.querySelector('a');
  const tween = anime.set(bg, { scaleX: 0, transformOrigin: '50% 50%' });
  anime.set(content, { opacity: 0, translateY: 20 });

  return tween;
}

export function buttonAnim(el, delay = 0) {
  const elToTween = el instanceof HTMLElement ? el : el.node;
  const bg = elToTween.querySelector('.button__bg');
  const content = elToTween.querySelector('a');
  const tween = anime({
    targets: bg,
    scaleX: isTouchDevice() ? 1.2 : 1,
    scaleY: isTouchDevice() ? 1.2 : 1,
    delay,
    complete: () => {
      if (!isTouchDevice()) {
        bg.style.transform = '';
        bg.style.transformOrigin = '';
      }
      bg.setAttribute('data-animated', '');
    },
  });
  anime({
    targets: content,
    opacity: 1,
    translateY: 0,
    delay: delay + 300,
  });

  return tween;
}
